export class ViewDescriptor {
    constructor(id, name, title) {
        this.id = id;
        this.name = name;
        this.title = title;
    }
}
